import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import '@/styles/journal.css';
import useReveal from '@/hooks/useReveal';
import { PostCard } from '@/pages/JournalIndex';

const API = process.env.REACT_APP_BACKEND_URL;

export default function JournalStrip() {
  const [posts, setPosts] = useState([]);
  const ref = useReveal();

  useEffect(() => {
    let live = true;
    fetch(`${API}/api/blog/posts?limit=3`)
      .then((r) => r.json())
      .then((d) => live && setPosts(Array.isArray(d) ? d.slice(0, 3) : []))
      .catch(() => {});
    return () => { live = false; };
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="section" id="journal" data-testid="home-journal-strip">
      <div className="section-inner">
        <div className="jr-strip-head reveal" ref={ref}>
          <div className="section-head">
            <span className="section-eyebrow">MISSION LOGS</span>
            <h2 className="section-title">From the <span className="text-pink">Journal</span></h2>
            <p className="section-sub">
              Case studies, local SEO and GEO playbooks — written for businesses across Essex, Hertfordshire and Cambridgeshire.
            </p>
          </div>
          <Link to="/journal" className="boost-btn boost-btn-ghost" data-testid="home-journal-all">
            All articles <ArrowRight size={15} />
          </Link>
        </div>
        <div className="jr-grid">
          {posts.map((p) => <PostCard key={p.slug} post={p} testId={`home-journal-card-${p.slug}`} />)}
        </div>
      </div>
    </section>
  );
}
